import { assert, ReplicaType } from '@verdant-web/common';
import { default as jwtDecode } from 'jwt-decode';
export class ServerSyncEndpointProvider {
    constructor(config) {
        this.config = config;
        this.cached = null;
        this.type = ReplicaType.Realtime;
        this.getEndpoints = async () => {
            if (this.cached) {
                return this.cached;
            }
            let result;
            if (this.config.fetchAuth) {
                result = await this.config.fetchAuth();
            }
            else {
                result = await fetch(this.config.authEndpoint, {
                    credentials: 'include',
                }).then((res) => {
                    if (!res.ok) {
                        throw new Error(`Auth endpoint returned non-200 response: ${res.status}`);
                    }
                    else {
                        return res.json();
                    }
                });
            }
            assert(result.accessToken, 'No access token provided from auth endpoint');
            const decoded = jwtDecode(result.accessToken);
            assert(decoded.url, 'No sync endpoint provided from auth endpoint');
            assert(decoded.type !== undefined, 'No replica type provided from auth endpoint');
            this.type = parseInt(decoded.type + '');
            const url = new URL(decoded.url);
            url.protocol = url.protocol.replace('ws', 'http');
            const httpEndpoint = url.toString();
            url.protocol = url.protocol.replace('http', 'ws');
            const websocketEndpoint = url.toString();
            let fileEndpoint = decoded.file;
            if (!fileEndpoint) {
                // default to http endpoint + '/files';
                const fileUrl = new URL(httpEndpoint);
                fileUrl.pathname = fileUrl.pathname + '/files';
                fileEndpoint = fileUrl.toString();
            }
            this.cached = {
                http: httpEndpoint,
                websocket: websocketEndpoint,
                files: fileEndpoint,
                token: result.accessToken,
            };
            return this.cached;
        };
        if (!config.authEndpoint && !config.fetchAuth) {
            throw new Error('Either authEndpoint or fetchAuth must be provided to ServerSyncEndpointProvider');
        }
    }
}
//# sourceMappingURL=ServerSyncEndpointProvider.js.map